import React from 'react';
import { Evidence2 } from '@eas/common-web';
import { DictionaryRiverSide } from '../../models';
import { useValidationSchema } from './dict-river-sides-schema';
import { EvidenceAPI, PageKey, Permission, EntityName } from '../../enums';
import { ExportTags } from '../../enums/export-tags';
import { useDictionaryEvidence } from '../../components/evidence/dictionary-evidence/dictionary-evidence';
import { usePermission } from '../../components/permission/perm-evidence-hook';

export function DictionaryRiverSides() {
  const validationSchema = useValidationSchema();

  const permissions = usePermission<DictionaryRiverSide>({
    options: {
      NEW: [Permission.MuvRiverSide.MUV_RIVER_SIDE_CREATE],
      EDIT: [Permission.MuvRiverSide.MUV_RIVER_SIDE_UPDATE],
      REMOVE: [Permission.MuvRiverSide.MUV_RIVER_SIDE_DELETE],
      CHECK: [
        Permission.MuvRiverSide.MUV_RIVER_SIDE_CREATE,
        Permission.MuvRiverSide.MUV_RIVER_SIDE_UPDATE,
      ],
      SAVE: [
        Permission.MuvRiverSide.MUV_RIVER_SIDE_CREATE,
        Permission.MuvRiverSide.MUV_RIVER_SIDE_UPDATE,
      ],
      CLOSE: [
        Permission.MuvRiverSide.MUV_RIVER_SIDE_CREATE,
        Permission.MuvRiverSide.MUV_RIVER_SIDE_UPDATE,
      ],
    },
  });

  const evidence = useDictionaryEvidence<DictionaryRiverSide>(
    {
      identifier: PageKey.DICTIONARY_RIVER_SIDES,
      apiProps: {
        url: EvidenceAPI.DICTIONARY_RIVER_SIDES,
      },
      tableProps: {
        tableName: 'Břehy vodních toků',
        reportTag: ExportTags.DICTIONARY_RIVER_SIDES,
        defaultSorts: [],
      },
      detailProps: {
        entityName: EntityName.RIVER_SIDE,
        codePrefix: 'RIVER_SIDE',
        validationSchema,
        toolbarProps: {
          title: 'Břeh vodního toku',
          showBtn: permissions,
        },
      },
    },
    Permission.MuvRiverSide.MUV_RIVER_SIDE_INVALIDATE,
    Permission.MuvRiverSide.MUV_RIVER_SIDE_REVALIDATE
  );

  return <Evidence2 {...evidence} />;
}
